// external imports
import React, { useEffect, useState, useContext } from 'react';
import { Tooltip } from 'react-tooltip';
import PropTypes from 'prop-types';

// local imports
import exportConfig from '../../config';
import formatDate from '../../helpers/formatDate';

// custom hooks & context
import { pipelineContext } from '../../contexts/pipelineContext';
import { endpointContext } from '../../contexts/endpointContext';

const QCFormDaily = ({
	handleSubmit,
	formValue,
	setFormValue,
	formValid,
	setFormValid,
	loading,
	setCapturesUrl,
	user
}) => {
	const [todayDate, setTodayDate] = useState(() => {
		const today = new Date();
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const day = String(today.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	});
	const pipelineContextQCFormDaily = useContext(pipelineContext);
	const endpointContextQCFormDaily = useContext(endpointContext);

	useEffect(() => {
		let today = new Date();
	//	console.log(today.toISOString().substring(0, 10));
		let dd = new Date(formValue.formEndDate);

		setFormValue({
			...formValue,
			formLookback: 1,
			formEndDate: today.toISOString().substring(0, 10),
			formEndDateNow: today.toLocaleTimeString(),
			formStartDate: new Date(today.setDate(today.getDate() - 1))
				.toISOString()
				.substring(0, 10)
		});
		//setTodayDate(today.toISOString().substring(0, 10));
	}, []);

	useEffect(() => {
		validateForm();

		// 08/10/24 LC - this should always be assign_captures, but the stockpiles EP for this is not
		// ready so we have to use the captures EP
		if (pipelineContextQCFormDaily.comm === 'smelters') {
			setCapturesUrl(
				`assign_captures?startDate=${formValue.formStartDate}
				&endDate=${formValue.formEndDate}&sensors=${formValue.formSensors.join(
					','
				)}&commodityIds=${formValue.formCommodities.join(
					','
				)}&prodStates=${formValue.formProdStates.join(
					','
				)}&qcUser=${user.givenName.toLowerCase()}.${user.familyName.toLowerCase()}&qcStates=0&expirationTime=240`
			);
		} else {
			setCapturesUrl(
				`captures?&siteTypeIds=3&startDate=${formValue.formStartDate}&endDate=${
					formValue.formEndDate
				}&sensors=${formValue.formSensors.join(
					','
				)}&commodities=${formValue.formCommodities.join(
					','
				)}&prodStates=${formValue.formProdStates.join(
					','
				)}&qcUser=${user.givenName.toLowerCase()}.${user.familyName.toLowerCase()}`
			);
		}
	}, [formValue]);

	const validateForm = () => {
		if (
			formValue.formCommodities.length > 0 &&
			formValue.formProdStates.length > 0 &&
			formValue.formSensors.length > 0 &&
			!parseInt(formValue.formLookback).isNaN
		) {
			setFormValid(true);
		} else {
			setFormValid(false);
		}
	};

	const calcDate = (e) => {
		let eDate, sDate, sDate2;

		if (e.target.name === 'formLookback') {
			eDate = new Date(formValue.formEndDate);
			sDate = eDate.setDate(eDate.getDate() - e.target.value);
			sDate2 = new Date(sDate).toISOString().substring(0, 10);
			setFormValue({
				...formValue,
				formStartDate: sDate2,
				formLookback: e.target.value
			});
		}

		if (e.target.name === 'formEndDate') {
			eDate = new Date(e.target.value);
			sDate = eDate.setDate(eDate.getDate() - formValue.formLookback);
			sDate2 = new Date(sDate).toISOString().substring(0, 10);

			setFormValue({
				...formValue,
				formEndDate: e.target.value,
				formStartDate: sDate2
			});
		}
	};

	const handleOnChange = (event, category) => {
		const { value, checked } = event.target;

		const finalValue = isNaN(parseInt(value)) ? value : parseInt(value);

		setFormValue((prevFormValue) => {
			const updatedCategory = checked
				? [...prevFormValue[category], finalValue]
				: prevFormValue[category].filter((item) => item !== finalValue);

			return {
				...prevFormValue,
				[category]: updatedCategory
			};
		});
	};

	const handleBackButton = (e) => {
		e.preventDefault();
		setFormValue({
			formSiteId: '',
			formStartDate: '',
			formEndDate: new Date().toISOString().substring(0, 10),
			formAutoQC: true,
			formEndDateNow: '',
			fullHistory: true,
			formSensors: ['sentinel-2-l1c', 'landsat-8-l1tp'],
			formCommodities: [3],
			formProdStates: [0, 1],
			formLookback: 1,
			manuallySelectSites: true
		});

		pipelineContextQCFormDaily.setProgressBar({
			width: 2 * (100 / 7),
			title: 'QC Type'
		});
		pipelineContextQCFormDaily.setQCType(undefined);
	};

	// console.log('Form value', formValue);
	// console.log(todayDate);

	return (
		<>
			<hr></hr>
			<form onSubmit={handleSubmit} className="px-3 mx-3">
				<div className="row">
					<div className="col d-flex justify-content-start align-items-center">
						<button
							className="btn interactButtonSecondary backButton"
							onClick={handleBackButton}
							style={{ width: '200px' }}
						>
							<i className="fa-solid fa-left-long pe-3"></i>
							Change QC type
						</button>
						<h1 className="ms-5 mt-2">QC</h1>
					</div>
					<div className="col"></div>
					<div className="col d-flex flex-column justify-content-center align-items-end">
						{formValid && !loading ? (
							<>
								<button
									type="submit"
									className="btn interactButton mt-2 mx-0"
									style={{ maxHeight: '40px', width: '200px' }}
									data-tooltip-id="view-captures-TT"
								>
									View captures <i className="fa-solid fa-right-long ps-2"></i>
								</button>
							</>
						) : (
							<button
								disabled
								className="btn btn-secondary mt-2 mx-0"
								style={{ maxHeight: '40px', width: '200px' }}
								data-tooltip-id="view-captures-TT"
							>
								View captures <i className="fa-solid fa-right-long ps-2"></i>
							</button>
						)}
					</div>
				</div>

				<Tooltip id="view-captures-TT" place="bottom" effect="solid">
					Fetch captures from database and view list before QCing
				</Tooltip>

				<h4 className="py-3">
					Fill in the captures criteria for{' '}
					<span className="fw-bold">daily QC</span>
				</h4>

				<div className="row mt-5">
					<div className="col-lg-2 col-6">
						<div className="form-group">
							<h5 className="card-title">Commodity</h5>
							<p className="fst-italic">Select one</p>

							<br></br>
							{endpointContextQCFormDaily.dbData.allCommodities
								.filter(
									(comm) =>
										`${comm.siteTypeStr}s` === pipelineContextQCFormDaily.comm
								)
								.map((comm, idx) => (
									<div key={idx}>
										<input
											className="form-check-input form-commodity"
											key={idx}
											type="radio"
											id={comm.id}
											name="daily-qc-comms"
											value={comm.id}
											onClick={(e) =>
												setFormValue({
													...formValue,
													formCommodities: [comm.id]
												})
											}
											checked={formValue.formCommodities.includes(comm.id)}
										></input>
										<label className="px-2" for={comm.id}>
											{comm.name}
										</label>
										<br></br>
									</div>
								))}
						</div>
						<br></br>

						{formValue.formCommodities.length === 0 && (
							<p id="comm-err" className="text-warning">
								<i className="fa-solid fa-triangle-exclamation"></i> Select at
								least one commodity
							</p>
						)}
					</div>

					<div className="col-lg-3 col-12">
						<h5 className="card-title">Production State</h5>
						<p className="fst-italic">Select at least one</p>

						<br></br>
						{exportConfig.production_states.map(
							({ state, descript, formText }, idx) => (
								<>
									<input
										className="form-check-input form-prod-state"
										type="checkbox"
										id={state}
										name="daily-qc-prods"
										value={state}
										checked={formValue.formProdStates.includes(state)}
										onChange={(e) => handleOnChange(e, 'formProdStates')}
									></input>
									<label
										className="px-2"
										for={state}
										data-tooltip-id={`prodStatToolTip${state}`}
									>
										{`${state} - ${formText}`}
									</label>{' '}
									<Tooltip
										id={`prodStatToolTip${state}`}
										place="top"
										effect="solid"
									>
										{descript}
									</Tooltip>
									<br></br>
								</>
							)
						)}
						{formValue.formProdStates.length === 0 && (
							<p id="prod-state-err" className="text-warning pt-3">
								<i className="fa-solid fa-triangle-exclamation"></i> Select at
								least one production state
							</p>
						)}
					</div>

					<div className="col-lg-2 col-6">
						<div className="form-group">
							<h5 className="card-title">Sensor</h5>
							<p className="fst-italic">Select at least one</p> <br></br>
							{exportConfig.sensors.map((sensor, idx) => (
								<div key={idx}>
									<input
										className="form-check-input form-sensor"
										type="checkbox"
										id={sensor}
										name="formSensors"
										value={sensor}
										onChange={(e) => handleOnChange(e, 'formSensors')}
										checked={formValue.formSensors.includes(sensor)}
									></input>
									<label className="px-2" for={sensor}>
										{sensor}
									</label>
								</div>
							))}
							{formValue.formSensors.length === 0 && (
								<p id="sensor-err" className="text-warning pt-3">
									<i className="fa-solid fa-triangle-exclamation"></i> Select at
									least one sensor
								</p>
							)}
						</div>
					</div>

					<div className="col-lg-3 col-12">
						<div className="form-group">
							<h5 className="card-title">Interval</h5>
							<p className="fst-italic">
								Adjust lookback days or end data to adjust interval
							</p>{' '}
							<br></br>
							<label for="num-lookback-days">
								Days lookback: <strong>{formValue.formLookback}</strong>
							</label>
							<input
								type="range"
								className="form-range"
								id="lookback-range"
								name="formLookback"
								min={1}
								max={10}
								step={1}
								value={parseInt(formValue.formLookback)}
								onChange={(e) => calcDate(e)}
							></input>
							<div className="row my-3">
								<div className="col-6 pe-1">
									<label for="start_date">Start date</label> <br></br>
									<input
										className="form-control text-sm"
										id="start_date"
										name="start_date"
										title="start date of interval"
										type="date"
										value={formValue.formStartDate}
										disabled
									></input>
									<br></br>
								</div>
								<div className="col-6 ps-1">
									<label for="end_date">End date</label>
									<br></br>
									<input
										className="form-control text-sm"
										id="end_date"
										name="formEndDate"
										title="End date of interval"
										type="date"
										max={todayDate}
										value={formValue.formEndDate}
										onChange={(e) => calcDate(e)}
									></input>
									<br></br>
								</div>
							</div>
							<div className="row">
								<h6>Selecting captures between</h6>

								<div className="col-5 d-flex justify-content-evenly">
									<span className="fw-bold">
										{formatDate(formValue.formStartDate)}
									</span>
									<p> at </p>
									<span className="fw-bold"> 00:00</span>
								</div>
								<div className="col-2 d-flex justify-content-center">and </div>
								<div className="col-5 d-flex justify-content-evenly">
									<span className="fw-bold">
										{formatDate(formValue.formEndDate)}
									</span>{' '}
									at{' '}
									<span className="fw-bold">
										{formValue.formEndDateNow.slice(0, 5)}
									</span>
								</div>
							</div>
						</div>
					</div>

					<div className="col-lg-2 col-12">
						{exportConfig.gainsEnvironment === 'dev' && (
							<div className="form-group">
								<h5 className="card-title">Captures limit</h5>
								<p className="fst-italic">
									Limit number of captures assigned
								</p>{' '}
								<br></br>
								<label for="caps_limit">Count limit</label>
								<input
									type="number"
									value={
										formValue.capsCountLimit !== null
											? formValue.capsCountLimit
											: ''
									}
									className="form-control text-sm"
									id="caps_limit"
									name="formEndDate"
									title="Captures limit"
									min={1}
									max={100}
									onChange={(e) =>
										setFormValue({
											...formValue,
											capsCountLimit: parseInt(e.target.value)
										})
									}
								></input>
							</div>
						)}
					</div>
				</div>
			</form>
		</>
	);
};

QCFormDaily.propTypes = {
	handleSubmit: PropTypes.func,
	formValue: PropTypes.object,
	setFormValue: PropTypes.func,
	formValid: PropTypes.bool,
	setFormValid: PropTypes.func,
	loading: PropTypes.bool,
	setCapturesUrl: PropTypes.func,
	user: PropTypes.object
};

export default QCFormDaily;
